module.exports = __webpack_public_path__ + "static/mountainhouse-0025d979abb43e28537130529a582c5e.jpg";